import React from 'react'

interface State {
  hasError: boolean
  error?: Error
}

/**
 * 顶层 ErrorBoundary 组件
 *
 * 捕获子组件树中未处理的 JavaScript 错误，防止整个应用白屏。
 * 显示错误信息和"重新加载"按钮，让用户可以恢复。
 */
class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[AppErrorBoundary] 捕获错误:', error, info)
  }

  handleReload = () => {
    this.setState({ hasError: false, error: undefined })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: 48,
          textAlign: 'center',
          fontFamily: 'system-ui, sans-serif',
        }}>
          <h2 style={{ marginBottom: 16, fontSize: 20, fontWeight: 600 }}>
            应用遇到错误
          </h2>
          <p style={{ marginBottom: 24, color: '#6b7280', fontSize: 14, maxWidth: 400 }}>
            {this.state.error?.message || '发生了未知错误'}
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '8px 24px',
              borderRadius: 8,
              border: 'none',
              background: '#0ea5e9',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            重新加载
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default AppErrorBoundary
